import { render, staticRenderFns } from "./VendorForms.vue?vue&type=template&id=580cabb4&scoped=true"
import script from "./VendorForms.vue?vue&type=script&lang=js"
export * from "./VendorForms.vue?vue&type=script&lang=js"
import style0 from "./VendorForms.vue?vue&type=style&index=0&id=580cabb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cabb4",
  null
  
)

export default component.exports